"use client";
import React from 'react';
import Image from "next/image";



interface HeroHeaderProps {
  imageSrc?: string;
  imageAlt?: string;
  title?: string;
  highlight_title?: string;
  tag?: string;
  secondaryTag?: string;
  secondaryTagClassName?: string;
  publishDate?: string;
}

export const HeroHeader: React.FC<HeroHeaderProps> = ({
  imageSrc = "/foto.png",
  imageAlt = "Hero background",
  title = "",
  tag = "",
  secondaryTag = "",
  secondaryTagClassName = "bg-[#F7941D] text-white",
  publishDate = "",
}) => {
  const normalizedSrc = imageSrc && (imageSrc.startsWith('http') || imageSrc.startsWith('/')) ? imageSrc : '/foto.png';

  return (
    <div className="relative w-full overflow-hidden mt-20 lg:mt-24">
      {/* Desktop version */}
      <div className="hidden lg:block relative w-full h-64 overflow-hidden">
        {/* Background image */}
        <Image
          src={normalizedSrc}
          className="object-cover object-center"
          alt={imageAlt}
          fill
          priority
        />

        {/* Orange gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500/50 to-stone-500/0" />

        {/* Title and tag positioned on the left */}
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="pl-4 sm:pl-6 lg:pl-10 flex flex-col">
              {/* Tags row */}
              <div className="flex items-center gap-2 mb-2">
                {tag && (
                  <span className="inline-block bg-white/40 text-[#2A2A2A] text-xs font-bold font-['Barlow_Semi_Condensed'] uppercase px-3 py-1 rounded">
                    {tag}
                  </span>
                )}
                {secondaryTag && (
                  <span className={`inline-block text-xs font-bold font-['Barlow_Semi_Condensed'] uppercase px-3 py-1 rounded ${secondaryTagClassName}`}>
                    {secondaryTag}
                  </span>
                )}
              </div>

              <h1 className="text-[#f9f7f7] text-4xl font-bold font-['Barlow_Semi_Condensed'] uppercase leading-10 max-w-[700px]">
                {title}
              </h1>

              {publishDate && (
                <p className=" text-md font-semibold font-['Nunito'] mt-3">
                  Data de Publicação: {publishDate}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile version */}
      <div className="block lg:hidden relative w-full h-52 sm:h-60 overflow-hidden">
        {/* Background image */}
        <Image
          src={normalizedSrc}
          className="object-cover object-center"
          alt={imageAlt}
          fill
          priority
        />

        {/* Orange gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500/50 to-stone-500/0" />

        {/* Title and tag positioned on the left */}
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="pl-4 sm:pl-6 flex flex-col">
              {/* Tags row */}
              <div className="flex items-center gap-2 mb-2">
                {tag && (
                  <span className="inline-block bg-white/40 text-fpef-color text-xs font-bold font-['Barlow_Semi_Condensed'] uppercase px-2 py-1 rounded">
                    {tag}
                  </span>
                )}
                {secondaryTag && (
                  <span className={`inline-block text-xs font-bold font-['Barlow_Semi_Condensed'] uppercase px-2 py-1 rounded ${secondaryTagClassName}`}>
                    {secondaryTag}
                  </span>
                )}
              </div>

              <h1 className="text-[#f9f7f7] text-2xl sm:text-3xl font-bold font-['Barlow_Semi_Condensed'] uppercase leading-tight max-w-[700px]">
                {title}
              </h1>

              {publishDate && (
                <p className="text-[#f9f7f7] text-xs sm:text-sm font-normal font-['Nunito'] mt-2">
                  Data de Publicação: {publishDate}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroHeader;
